<template>
  <div class="text-container">
    <span
      :style="{
        animationDuration: animDuration + 's',
        animationDelay: animDelay + 's',
      }"
      class="fadeTextIn"
      v-html="data ? data[0].label : ''"
    ></span>
  </div>
</template>

<style lang="scss" scoped>
.text-container {
  background-color: $white100;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 64px;
  font-weight: bold;
  line-height: 64px;
  color: $blue100;
  text-align: left;

  max-width: 98%;
  min-width: 50%;
  width: fit-content;
  min-height: 50px;

  margin: auto;
  padding: 15px 30px 15px 30px;

  border-radius: 10px;

  @media (max-width: 1200px) {
    font-size: 20px;
    line-height: 20px;
  }
}

.fadeTextIn {
  opacity: 0;
  animation-name: fade-in;
  animation-fill-mode: forwards;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>

<script lang="ts">
import { IActivityComponentData } from '@/models/interfaces/activities';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ActivityLargeTextContainer extends Vue {
  @Prop({ default: null })
  private data!: IActivityComponentData;

  @Prop({ default: 1 })
  private animDuration!: number;

  @Prop({ default: 0.4 })
  private animDelay!: number;
}
</script>

<docs>
A text/content wrapper component for activities


### Varian with a simple text

```jsx
<ActivityTextContainer>
  Simple text
</ActivityTextContainer>
```

### Varian with random content

```jsx
<ActivityTextContainer>
  <img
    src="https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg"
    alt="Test Text Container Image"
    title="Test Text Container Image"
    height="100"
  />
</ActivityTextContainer>
```
</docs>
